import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const Container = styled.div``;

export const InputField = styled.input<{
  placeholder: string;
  theme: Theme;
}>`
  font-size: 18px;
  padding: 15px;
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.inputBorder};
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  width: 100%;
  ::placeholder {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({theme}) => theme.inputPlaceholder};
  }
`;

export const InputLabel = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  text-align: left;
  color: #00234d;
  margin-left: 10px;
  margin-top: 20px;
`;
